const List = () =>
  import(/* webpackChunkName: "client" */ '@/views/client/List.vue')
const Detail = () =>
  import(/* webpackChunkName: "client" */ '@/views/client/Detail.vue')
const ServiceProviderClient = () =>
  import(
    /* webpackChunkName: "client" */ '@/views/client/ServiceProviderClient.vue'
  )

const CustomerResource = () =>
  import('@/views/client/customerResource/List.vue')

export default function (router) {
  router.push({
    path: '/partner/client',
    component: List,
    redirect: '/partner/client/list',
  })
  // 客户管理
  router.push({
    path: '/partner/client/list',
    name: 'clientList',
    component: List,
    meta: {
      keepAlive: true,
      isDistributor: true, // 校验权限是否为渠道商
      currPage: 'partnerClientManage',
    },
  })
  // 客户详情
  router.push({
    path: '/partner/client/detail/:pin',
    name: 'clientDetail',
    component: Detail,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      currPage: 'partnerClientManage',
    },
  })

  // 下级渠道商客户
  router.push({
    path: '/partner/client/service-provider-client',
    redirect: '/partner/client/service-provider-client/list',
    component: ServiceProviderClient,
  })

  // 渠道商客户列表
  router.push({
    path: '/partner/client/service-provider-client/list',
    name: 'ServiceProviderClient',
    component: ServiceProviderClient,
    meta: {
      keepAlive: true,
      isDistributor: true, // 校验权限是否为渠道商
      isFirstDistributor: true, // 校验是否为一级渠道商
      currPage: 'partnerServiceProviderClient',
    },
  })

  // 渠道客户资源
  router.push({
    path: '/partner/client/customerResource',
    name: 'customerResource',
    component: CustomerResource,
    meta: {
      keepAlive: true,
      isDistributor: true,
    },
  })
}
